"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.ColorWithoutWarning = exports.Color = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
// 颜色枚举，1 ～ 14
var Color;
(function (Color) {
    Color[Color["Blue"] = 1] = "Blue";
    Color[Color["SkyBlue"] = 2] = "SkyBlue";
    Color[Color["Turquoise"] = 3] = "Turquoise";
    Color[Color["Green"] = 4] = "Green";
    Color[Color["Purple"] = 5] = "Purple";
    Color[Color["Pink"] = 6] = "Pink";
    Color[Color["Orange"] = 7] = "Orange";
    Color[Color["Red"] = 8] = "Red";
    Color[Color["DarkRed"] = 9] = "DarkRed";
    Color[Color["DarkPurple"] = 10] = "DarkPurple";
    Color[Color["LakeBlue"] = 11] = "LakeBlue";
    Color[Color["LightLakeBlue"] = 12] = "LightLakeBlue";
    Color[Color["LightSkyBlue"] = 13] = "LightSkyBlue";
    Color[Color["LightGreen"] = 14] = "LightGreen";
})(Color = exports.Color || (exports.Color = {}));
// 颜色值
var ColorMap = (_a = {},
    _a[Color.Blue] = "#2670E8",
    _a[Color.SkyBlue] = "#2985C7",
    _a[Color.Turquoise] = "#27B3BC",
    _a[Color.Green] = "#29C770",
    _a[Color.Purple] = "#A846FF",
    _a[Color.Pink] = "#E85C5C",
    _a[Color.Orange] = "#FF8420",
    _a[Color.Red] = "#CE2719",
    _a[Color.DarkRed] = "#B42C62",
    _a[Color.DarkPurple] = "#591EE1",
    _a[Color.LakeBlue] = "#3853F5",
    _a[Color.LightLakeBlue] = "#3C89DD",
    _a[Color.LightSkyBlue] = "#578AF7",
    _a[Color.LightGreen] = "#53B9A2",
    _a);
var ColorWithoutWarning;
(function (ColorWithoutWarning) {
    ColorWithoutWarning[ColorWithoutWarning["Blue"] = 1] = "Blue";
    ColorWithoutWarning[ColorWithoutWarning["SkyBlue"] = 2] = "SkyBlue";
    ColorWithoutWarning[ColorWithoutWarning["Turquoise"] = 3] = "Turquoise";
    ColorWithoutWarning[ColorWithoutWarning["Purple"] = 4] = "Purple";
    ColorWithoutWarning[ColorWithoutWarning["DarkRed"] = 5] = "DarkRed";
    ColorWithoutWarning[ColorWithoutWarning["DarkPurple"] = 6] = "DarkPurple";
    ColorWithoutWarning[ColorWithoutWarning["LakeBlue"] = 7] = "LakeBlue";
    ColorWithoutWarning[ColorWithoutWarning["LightLakeBlue"] = 8] = "LightLakeBlue";
    ColorWithoutWarning[ColorWithoutWarning["LightSkyBlue"] = 9] = "LightSkyBlue";
})(ColorWithoutWarning = exports.ColorWithoutWarning || (exports.ColorWithoutWarning = {}));
var ColorMapWithoutWarning = (_b = {},
    _b[ColorWithoutWarning.Blue] = "#2670E8",
    _b[ColorWithoutWarning.SkyBlue] = "#2985C7",
    _b[ColorWithoutWarning.Turquoise] = "#27B3BC",
    _b[ColorWithoutWarning.Purple] = "#A846FF",
    _b[ColorWithoutWarning.DarkRed] = "#B42C62",
    _b[ColorWithoutWarning.DarkPurple] = "#591EE1",
    _b[ColorWithoutWarning.LakeBlue] = "#3853F5",
    _b[ColorWithoutWarning.LightLakeBlue] = "#3C89DD",
    _b[ColorWithoutWarning.LightSkyBlue] = "#578AF7",
    _b);
// 文案颜色
var TextColor;
(function (TextColor) {
    TextColor["Light"] = "#ffffff";
    TextColor["Dark"] = "#000000";
})(TextColor || (TextColor = {}));
exports.Avatar = forward_ref_with_statics_1.forwardRefWithStatics(function Avatar(_a, ref) {
    var _b = _a.width, width = _b === void 0 ? 38 : _b, _c = _a.height, height = _c === void 0 ? 38 : _c, color = _a.color, text = _a.text, textColorProp = _a.textColor, badge = _a.badge;
    var _d = tslib_1.__read(react_1.useMemo(function () {
        var textColor = TextColor.Light;
        var backColor = ColorMap[Color.Blue];
        if (typeof color === "number" && ColorMap[color]) {
            backColor = ColorMap[color];
        }
        if (typeof color === "string") {
            if (/^#([a-fA-F\d]{6}|[a-fA-F\d]{3})$|^rgb/.test(color)) {
                backColor = color;
            }
            else {
                // 字符串哈希
                var hash = 5381;
                for (var i = 0, len = color.length; i < len; ++i) {
                    hash += (hash << 5) + color.charCodeAt(i);
                }
                // 传入文字是数字只显示 9 种颜色
                var colorNumTotal = Number.isNaN(+text) ? 14 : 9;
                var colorNum = Math.abs(hash % colorNumTotal) + 1;
                backColor = Number.isNaN(+text)
                    ? ColorMap[colorNum]
                    : ColorMapWithoutWarning[colorNum];
            }
        }
        return [textColorProp || textColor, backColor];
    }, [color, text, textColorProp]), 2), textColor = _d[0], backColor = _d[1];
    return (react_1.default.createElement("svg", { ref: ref, width: width, height: height, viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { x: "1", y: "1", width: "36", height: "36", rx: "18", fill: backColor }),
            react_1.default.createElement("text", { fill: textColor, x: "19", y: "20", dominantBaseline: "middle", style: { textAnchor: "middle" }, fontFamily: "PingFang SC", fontSize: "18", fontWeight: "500" }, text)),
        badge && react_1.default.createElement("circle", { cx: "34", cy: "10", r: "4", fill: "#F64041" })));
}, { Color: Color });
exports.Avatar.displayName = "Avatar";
//# sourceMappingURL=Avatar.js.map